import { combineReducers } from "redux";
import search_result from "./search_result";
import loading_status from "./loading_status";
import alert_status from "./alert_status";

export default combineReducers({ search_result, loading_status, alert_status });
